import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, History } from "lucide-react";

// Swipe left = older (next in newest-first list), right = newer.
export function useSwipe(onLeft, onRight) {
  const start = useRef(null);
  return {
    onTouchStart: (e) => {
      if (e.target.closest?.("input,textarea,select,button[role=switch],[role=slider],[data-noswipe],[contenteditable=true]")) { start.current = null; return; }
      const t = e.touches[0]; start.current = { x: t.clientX, y: t.clientY };
    },
    onTouchEnd: (e) => {
      if (!start.current) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - start.current.x, dy = t.clientY - start.current.y;
      start.current = null;
      if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      if (dx < 0) onLeft(); else onRight();
    },
  };
}

export function ResultPager({ index, total, onNewer, onOlder, hint = "swipe to browse" }) {
  if (index < 0 || total < 2) return null;
  const btn = "flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 transition-colors hover:text-[#0053DA] disabled:opacity-30";
  return (
    <div className="mb-2 flex items-center justify-between" data-testid="result-pager">
      <button type="button" onClick={onNewer} disabled={index === 0} aria-label="Newer item" className={btn} data-testid="result-newer"><ChevronLeft className="h-4 w-4" /></button>
      <span className="font-mono text-[11px] text-slate-500" data-testid="result-position">{index + 1} of {total} · {hint}</span>
      <button type="button" onClick={onOlder} disabled={index === total - 1} aria-label="Older item" className={btn} data-testid="result-older"><ChevronRight className="h-4 w-4" /></button>
    </div>
  );
}

export function BackToHistory({ targetRef, active }) {
  const [hidden, setHidden] = useState(true);
  useEffect(() => {
    const el = targetRef.current;
    if (!el || !active) return undefined;
    const io = new IntersectionObserver(([e]) => setHidden(e.isIntersecting || e.boundingClientRect.top > 0));
    io.observe(el);
    return () => io.disconnect();
  }, [targetRef, active]);
  if (!active || hidden) return null;
  return (
    <button type="button" onClick={() => targetRef.current?.scrollIntoView({ behavior: "smooth", block: "start" })}
      data-testid="back-to-history-btn"
      className="slide-in fixed right-4 z-40 flex items-center gap-1.5 rounded-full bg-[#0053DA] px-4 py-2.5 text-xs font-semibold text-white shadow-lg shadow-blue-900/20 transition-transform active:scale-95"
      style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 1rem)" }}>
      <History className="h-3.5 w-3.5" /> Back to history
    </button>
  );
}
